import { IRootState } from '../../app/store';

export const selectAppConfigs = (state: IRootState) =>
    state.appConfigs.appConfigs;

export const selectAppConfigsAsyncStatus = (state: IRootState) =>
    state.appConfigs.appConfigsAsyncStatus;

export const selectAppRuntimeConfigsAsyncStatus = (state: IRootState) =>
    state.appConfigs.appRuntimeConfigsAsyncStatus;
